import styled from 'styled-components';
import { Icon, IconName } from '@optimus-web/core';

const COLOR_WHITE = '#ffffff';
const SIZE = '36px';
const COMMON_ICON_STYLE = `
    position: absolute;
    top: 0px;
    left: 0px;
    color: ${COLOR_WHITE};
    transition: all 80ms linear;
`;
const IconWrapper = styled.div`
    height: ${SIZE};
    width: ${SIZE};
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ChatIcon = styled(Icon)`
    ${COMMON_ICON_STYLE}
    transform: rotate(0deg);
    opacity: 1;

    svg {
        height: ${SIZE};
        width: ${SIZE};
    }

    ${(props) =>
        (props as $TSFixMe).opened &&
        `
        font-size: 0px;
        transform: rotate(45deg);
        opacity: 0;
    `}
`;

const CloseIcon = styled(Icon)`
    ${COMMON_ICON_STYLE}
    font-size: 28px;
    transform: rotate(-45deg);
    opacity: 0;

    ${(props) =>
        (props as $TSFixMe).opened &&
        `
        font-size: 0px;
        transform: rotate(0deg);
        opacity: 1;
    `}
`;

export default (props: $TSFixMe) => (
    <IconWrapper>
        {/* @ts-expect-error $TSFixMeError: No overload matches this call. */}
        <ChatIcon value={IconName.HelpCenter} opened={props.opened} />
        {/* @ts-expect-error $TSFixMeError: No overload matches this call. */}
        <CloseIcon value={IconName.CrossClose} opened={props.opened} />
    </IconWrapper>
);
